import { format } from 'date-fns'
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import type { TimeSeriesPoint } from '@/api/hooks/use-analytics'

interface VolumeChartProps {
  data: TimeSeriesPoint[]
}

export function VolumeChart({ data }: VolumeChartProps): React.JSX.Element {
  return (
    <div className="rounded-xl border border-surface-3 bg-surface-0 p-6">
      <div className="mb-4">
        <h3 className="text-sm font-medium text-text-primary">Send Volume</h3>
        <p className="text-xs text-text-tertiary">Sent vs Delivered over time</p>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-surface-3)" />
          <XAxis
            dataKey="timestamp"
            tickFormatter={(v: string) => format(new Date(v), 'MMM d')}
            stroke="var(--color-text-tertiary)"
            fontSize={12}
          />
          <YAxis stroke="var(--color-text-tertiary)" fontSize={12} />
          <Tooltip
            labelFormatter={(v: string) => format(new Date(v), 'MMM d, yyyy HH:mm')}
            contentStyle={{
              backgroundColor: 'var(--color-surface-0)',
              border: '1px solid var(--color-surface-3)',
              borderRadius: '8px',
              fontSize: '12px',
            }}
          />
          <Area
            type="monotone"
            dataKey="sent"
            stroke="var(--color-brand-500)"
            fill="var(--color-brand-100)"
            strokeWidth={2}
            name="Sent"
          />
          <Area
            type="monotone"
            dataKey="delivered"
            stroke="var(--color-success)"
            fill="var(--color-success)"
            fillOpacity={0.15}
            strokeWidth={2}
            name="Delivered"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  )
}
